import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HasElementsPipe } from './has-elements.pipe';

@NgModule({
  declarations: [HasElementsPipe],
  imports: [CommonModule],
  exports: [HasElementsPipe]
})
export class HasElementsModule {}
